import { render } from "./SingleJob.vue?vue&type=template&id=1825624c&scoped=true"
import script from "./SingleJob.vue?vue&type=script&lang=js"
export * from "./SingleJob.vue?vue&type=script&lang=js"

import "./SingleJob.vue?vue&type=style&index=0&id=1825624c&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1825624c"]])

export default __exports__